import { useRecoilValue } from 'recoil';
import { cartAtom } from '../../atoms/cartAtom';
import { logger } from 'common-ui';
import { fetchCart } from '../../services/cart';

export function useInitCartStateWithAtgLegacyApi() {
  const { cartItems } = useRecoilValue(cartAtom);

  return async (): Promise<void> => {
    if (cartItems) {
      logger.log('skipping init fetch of cart data as already defined');
      return;
    }
    await fetchCart();
  };
}
